<template lang="pug">
    .comment-compo
        .list-comment.row(v-for="comment in commentList")
            .col-sm-2.u-info
                strong {{comment.username}}
            .col-sm-10.comment-text {{comment.content}}
</template>
<script>
import Vue from 'vue'
import util from "../lib/util"
import $ from "jquery"
export default {
    name: 'Comment',
    props : [
        "id" , "load" , "refresh"
    ],
    data : function(){
        return {
            commentList : [],
        };
    },
    beforeMount : function(){
        this.loadData();
    },

    methods : {

        loadData : function(){
            var mThis = this;
            $.getJSON(`/photos/getCommentsList/?ajax=1&pid=${this.id}&r=` + Math.random(),function(data){
                mThis.commentList = data.msg;
                mThis.$emit('loaded' , {id : mThis.id});
            });
        }
    },

    watch : {
        "refresh" : function(data) {
            this.loadData();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Comment.vue